import styles from './ParcellingTabs.module.css';

interface ParcellingTabsProps {
	activeTab: 'manual' | 'flora';
	onTabChange: (tab: 'manual' | 'flora') => void;
	disabled?: boolean;
	isEditing?: boolean;
}

export const ParcellingTabs = ({ activeTab, onTabChange, disabled = false, isEditing = false }: ParcellingTabsProps) => {
	return (
		<div className={styles.tabs}>
			<button
				type="button"
				className={`${styles.tab} ${activeTab === 'manual' ? styles.tabActive : ''}`}
				onClick={() => onTabChange('manual')}
				disabled={disabled}
			>
				Manualmente
			</button>
			{isEditing && (
				<button
					type="button"
					className={`${styles.tab} ${activeTab === 'flora' ? styles.tabActive : ''}`}
					onClick={() => onTabChange('flora')}
					disabled={disabled}
				>
					Com Flora AI
				</button>
			)}
		</div>
	);
};
